<template>
  <div class="page-container">
  <PageHeader title="مدیریت چک‌ها" infoTitle="راهنمای مدیریت چک‌ها" :infoLearnUrl="infoLearnUrl" />
    <div class="check-management-container">
      <div class="tabs-nav">
        <button
          :class="['tab-button', { active: activeTab === 'issued' }]"
          @click="activeTab = 'issued'"
        >
          چک صادره
        </button>
        <button
          :class="['tab-button', { active: activeTab === 'received' }]"
          @click="activeTab = 'received'"
        >
          import PageHeader from '@/components/PageHeader.vue';
        </button>
        <button
          :class="['tab-button', { active: activeTab === 'free-print' }]"
          @click="activeTab = 'free-print'"
        >
          چک چاپ آزاد
        </button>
      </div>

      <div class="tab-content">
        <div v-if="activeTab === 'issued'" class="tab-pane">
          <form @submit.prevent="handleIssueCheck" class="check-form">
            <div class="form-group">
              <label for="account-number">شماره حساب</label>
              <input
                id="account-number"
                type="text"
                v-model="form.accountNumber"
              />
            </div>
            <div class="form-group">
              <label for="checkbook-id">شناسه دسته چک</label>
              <input id="checkbook-id" type="text" v-model="form.checkbookId" />
            </div>
            <div class="form-group">
              <label for="check-date">تاریخ چک</label>
              <div class="p-date">
                <DatePicker
                  v-model="form.checkDateJalali"
                  format="jYYYY/jMM/jDD"
                  display-format="jYYYY/jMM/jDD"
                  placeholder="تاریخ را انتخاب کنید"
                  auto-submit
                  :editable="true"
                />
              </div>
            </div>
            <div class="form-group">
              <label for="check-amount">مبلغ چک</label>
              <input
                id="check-amount"
                type="number"
                v-model="form.checkAmount"
              />
            </div>

            <div class="form-group">
              <label for="payable-to">متن در وجه</label>
              <input id="payable-to" type="text" v-model="form.payableTo" />
            </div>
            <div class="form-group">
              <label for="reason">متن بابت</label>
              <input id="reason" type="text" v-model="form.reason" />
            </div>
            <div class="form-group">
              <label for="national-id">کد ملی</label>
              <input id="national-id" type="text" v-model="form.nationalId" />
            </div>
            <div class="form-group">
              <label for="check-serial">سریال چک</label>
              <input id="check-serial" type="text" v-model="form.checkSerial" />
            </div>
          </form>
          <div class="form-actions">
            <BaseButton title="ثبت چک" variant="primary" @click="handleIssueCheck" />
          </div>

          <div class="table-section">
            <div class="table-controls">
              <div class="form-group-table">
                <label style="color: #5d5d5d" for="check-type">نوع چک</label>
                <select id="check-type" v-model="form.checkType">
                  <option>چک روز</option>
                  <option>چک مدت دار</option>
                  <option>چک تضمینی با تاریخ</option>
                  <option>چک تضمینی بدون تاریخ</option>
                </select>
              </div>
              <div class="search">
                <input
                  id="general-search"
                  type="text"
                  v-model="searchQuery"
                  placeholder="جستجو..."
                />
              </div>
            </div>

            <div class="status-filters">
              <button
                v-for="status in statusOptions"
                :key="status"
                @click="activeStatusFilter = status"
                :class="[
                  'status-button',
                  { active: activeStatusFilter === status },
                ]"
              >
                <span
                  v-if="status !== 'همه'"
                  class="color-indicator"
                  :class="status.toLowerCase().replace(/\s/g, '-')"
                ></span>
                {{ status }}
              </button>
            </div>

            <div class="table-wrapper">
              <table class="checks-table">
                <thead>
                  <tr>
                    <th>ردیف</th>
                    <th>سریال چک</th>
                    <th>مبلغ چک</th>
                    <th>تاریخ چک</th>
                    <th>نام بانک</th>
                    <th>شماره حساب</th>
                    <th>متن دروجه</th>
                    <th>متن بابت</th>
                    <th>نوع چک</th>
                    <th>وضعیت چک</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(check, index) in filteredChecks" :key="check.id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ check.checkSerial }}</td>
                    <td>{{ check.checkAmount?.toLocaleString() }}</td>
                    <td>{{ check.checkDate }}</td>
                    <td>{{ check.bankName }}</td>
                    <td>{{ check.accountNumber }}</td>
                    <td>{{ check.payableTo }}</td>
                    <td>{{ check.reason }}</td>
                    <td>{{ check.checkType }}</td>
                    <td>
                      <span
                        :class="[
                          'status-badge',
                          check.status.toLowerCase().replace(/\s/g, '-'),
                        ]"
                        >{{ check.status }}</span
                      >
                    </td>
                  </tr>

                  <tr v-if="filteredChecks.length === 0">
                    <td v-for="n in 10" :key="n">&nbsp;</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div v-if="activeTab === 'received'" class="tab-pane">
          <form @submit.prevent="handleReceiveCheck" class="check-form">
            <div class="form-group">
              <label for="account-number-receive">شماره حساب</label>
              <input
                id="account-number-receive"
                type="text"
                v-model="formReceive.accountNumber"
              />
            </div>
            <div class="form-group">
              <label for="checkbook-id-receive">شناسه دسته چک</label>
              <input id="checkbook-id-receive" type="text" v-model="formReceive.checkbookId" />
            </div>
            <div class="form-group">
              <label for="check-date-receive">تاریخ چک</label>
              <div class="p-date">
                <DatePicker
                  v-model="formReceive.checkDateJalali"
                  format="jYYYY/jMM/jDD"
                  display-format="jYYYY/jMM/jDD"
                  placeholder="تاریخ را انتخاب کنید"
                  auto-submit
                  :editable="true"
                />
              </div>
            </div>
            <div class="form-group">
              <label for="check-amount-receive">مبلغ چک</label>
              <input
                id="check-amount-receive"
                type="number"
                v-model="formReceive.checkAmount"
              />
            </div>

            <div class="form-group">
              <label for="payable-to-receive">متن در وجه</label>
              <input id="payable-to-receive" type="text" v-model="formReceive.payableTo" />
            </div>
            <div class="form-group">
              <label for="reason-receive">متن بابت</label>
              <input id="reason-receive" type="text" v-model="formReceive.reason" />
            </div>
            <div class="form-group">
              <label for="national-id-receive">کد ملی</label>
              <input id="national-id-receive" type="text" v-model="formReceive.nationalId" />
            </div>
            <div class="form-group">
              <label for="check-serial-receive">سریال چک</label>
              <input id="check-serial-receive" type="text" v-model="formReceive.checkSerial" />
            </div>
          </form>
          <div class="form-actions">
            <BaseButton title="ثبت چک دریافتی" variant="primary" @click="handleReceiveCheck" />
          </div>

          <div class="table-section">
            <div class="table-controls">
              <div class="form-group-table">
                <label style="color: #5d5d5d" for="check-type-receive">نوع چک</label>
                <select id="check-type-receive" v-model="formReceive.checkType">
                  <option>چک روز</option>
                  <option>چک مدت دار</option>
                  <option>چک تضمینی با تاریخ</option>
                  <option>چک تضمینی بدون تاریخ</option>
                </select>
              </div>
              <div class="search">
                <input
                  id="general-search-receive"
                  type="text"
                  v-model="searchQueryReceive"
                  placeholder="جستجو..."
                />
              </div>
            </div>
            <div class="status-filters">
              <button
                v-for="status in statusOptions"
                :key="status"
                @click="activeStatusFilterReceive = status"
                :class="[
                  'status-button',
                  { active: activeStatusFilterReceive === status },
                ]"
              >
                <span
                  v-if="status !== 'همه'"
                  class="color-indicator"
                  :class="status.toLowerCase().replace(/\s/g, '-')"
                ></span>
                {{ status }}
              </button>
            </div>

            <div class="table-wrapper">
              <table class="checks-table">
                <thead>
                  <tr>
                    <th>ردیف</th>
                    <th>سریال چک</th>
                    <th>مبلغ چک</th>
                    <th>تاریخ چک</th>
                    <th>نام بانک</th>
                    <th>شماره حساب</th>
                    <th>متن دروجه</th>
                    <th>متن بابت</th>
                    <th>نوع چک</th>
                    <th>وضعیت چک</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(check, index) in filteredChecksReceive" :key="check.id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ check.checkSerial }}</td>
                    <td>{{ check.checkAmount?.toLocaleString() }}</td>
                    <td>{{ check.checkDate }}</td>
                    <td>{{ check.bankName }}</td>
                    <td>{{ check.accountNumber }}</td>
                    <td>{{ check.payableTo }}</td>
                    <td>{{ check.reason }}</td>
                    <td>{{ check.checkType }}</td>
                    <td>
                      <span
                        :class="[
                          'status-badge',
                          check.status.toLowerCase().replace(/\s/g, '-'),
                        ]"
                        >{{ check.status }}</span
                      >
                    </td>
                  </tr>

                  <tr v-if="filteredChecksReceive.length === 0">
                    <td v-for="n in 10" :key="n">&nbsp;</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-if="activeTab === 'free-print'" class="tab-pane">
          <form @submit.prevent="handleFreePrintCheck" class="check-form">
            <div class="form-group">
              <label for="account-number-free">شماره حساب</label>
              <input
                id="account-number-free"
                type="text"
                v-model="formFree.accountNumber"
              />
            </div>
            <div class="form-group">
              <label for="checkbook-id-free">شناسه دسته چک</label>
              <input id="checkbook-id-free" type="text" v-model="formFree.checkbookId" />
            </div>
            <div class="form-group">
              <label for="check-date-free">تاریخ چک</label>
              <div class="p-date">
                <DatePicker
                  v-model="formFree.checkDateJalali"
                  format="jYYYY/jMM/jDD"
                  display-format="jYYYY/jMM/jDD"
                  placeholder="تاریخ را انتخاب کنید"
                  auto-submit
                  :editable="true"
                />
              </div>
            </div>
            <div class="form-group">
              <label for="check-amount-free">مبلغ چک</label>
              <input
                id="check-amount-free"
                type="number"
                v-model="formFree.checkAmount"
              />
            </div>

            <div class="form-group">
              <label for="payable-to-free">متن در وجه</label>
              <input id="payable-to-free" type="text" v-model="formFree.payableTo" />
            </div>
            <div class="form-group">
              <label for="reason-free">متن بابت</label>
              <input id="reason-free" type="text" v-model="formFree.reason" />
            </div>
            <div class="form-group">
              <label for="national-id-free">کد ملی</label>
              <input id="national-id-free" type="text" v-model="formFree.nationalId" />
            </div>
            <div class="form-group">
              <label for="check-serial-free">سریال چک</label>
              <input id="check-serial-free" type="text" v-model="formFree.checkSerial" />
            </div>
          </form>
          <div class="form-actions">
            <BaseButton title="ثبت چک چاپ آزاد" variant="primary" @click="handleFreePrintCheck" />
          </div>

          <div class="table-section">
            <div class="table-controls">
              <div class="form-group-table">
                <label style="color: #5d5d5d" for="check-type-free">نوع چک</label>
                <select id="check-type-free" v-model="formFree.checkType">
                  <option>چک روز</option>
                  <option>چک مدت دار</option>
                  <option>چک تضمینی با تاریخ</option>
                  <option>چک تضمینی بدون تاریخ</option>
                </select>
              </div>
              <div class="search">
                <input
                  id="general-search-free"
                  type="text"
                  v-model="searchQueryFree"
                  placeholder="جستجو..."
                />
              </div>
            </div>
            <div class="status-filters">
              <button
                v-for="status in statusOptions"
                :key="status"
                @click="activeStatusFilterFree = status"
                :class="[
                  'status-button',
                  { active: activeStatusFilterFree === status },
                ]"
              >
                <span
                  v-if="status !== 'همه'"
                  class="color-indicator"
                  :class="status.toLowerCase().replace(/\s/g, '-')"
                ></span>
                {{ status }}
              </button>
            </div>

            <div class="table-wrapper">
              <table class="checks-table">
                <thead>
                  <tr>
                    <th>ردیف</th>
                    <th>سریال چک</th>
                    <th>مبلغ چک</th>
                    <th>تاریخ چک</th>
                    <th>نام بانک</th>
                    <th>شماره حساب</th>
                    <th>متن دروجه</th>
                    <th>متن بابت</th>
                    <th>نوع چک</th>
                    <th>وضعیت چک</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(check, index) in filteredChecksFree" :key="check.id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ check.checkSerial }}</td>
                    <td>{{ check.checkAmount?.toLocaleString() }}</td>
                    <td>{{ check.checkDate }}</td>
                    <td>{{ check.bankName }}</td>
                    <td>{{ check.accountNumber }}</td>
                    <td>{{ check.payableTo }}</td>
                    <td>{{ check.reason }}</td>
                    <td>{{ check.checkType }}</td>
                    <td>
                      <span
                        :class="[
                          'status-badge',
                          check.status.toLowerCase().replace(/\s/g, '-'),
                        ]"
                        >{{ check.status }}</span
                      >
                    </td>
                  </tr>

                  <tr v-if="filteredChecksFree.length === 0">
                    <td v-for="n in 10" :key="n">&nbsp;</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import PageHeader from '@/components/PageHeader.vue';
import BaseButton from '@/components/UiCompunents/BaseButton.vue';
import { ref, reactive, computed } from "vue";

// --- State Management ---
const activeTab = ref("issued");

const form = reactive({
  checkDateJalali: "",
  accountNumber: "",
  checkbookId: "",
  checkDate: "",
  checkAmount: null,
  payableTo: "",
  reason: "",
  nationalId: "",
  checkSerial: "",
  checkType: "چک روز", // Default value for the selector
});

const formReceive = reactive({
  checkDateJalali: "",
  accountNumber: "",
  checkbookId: "",
  checkDate: "",
  checkAmount: null,
  payableTo: "",
  reason: "",
  nationalId: "",
  checkSerial: "",
  checkType: "چک روز",
});

const formFree = reactive({
  checkDateJalali: "",
  accountNumber: "",
  checkbookId: "",
  checkDate: "",
  checkAmount: null,
  payableTo: "",
  reason: "",
  nationalId: "",
  checkSerial: "",
  checkType: "چک روز",
});

// The main array to hold all checks
const checks = ref([]);

// Arrays for received and free print checks
const checksReceive = ref([]);
const checksFree = ref([]);

// Renamed for general search
const searchQuery = ref("");
const searchQueryReceive = ref("");
const searchQueryFree = ref("");

const statusOptions = [
  "همه",
  "درحال وصول",
  "واگذار شده",
  "پاس شده",
  "برگشت شده",
  "ابطال شده",
  "عودت",
];
const activeStatusFilter = ref("همه");
const activeStatusFilterReceive = ref("همه");
const activeStatusFilterFree = ref("همه");

// --- Computed Properties ---
// This automatically updates the table based on the active filters
const filteredChecks = computed(() => {
  let result = checks.value;

  // First, filter by status
  if (activeStatusFilter.value !== "همه") {
    result = result.filter(
      (check) => check.status === activeStatusFilter.value
    );
  }

  // Then, filter by the general search query
  const query = searchQuery.value.toLowerCase().trim();
  if (query) {
    result = result.filter((check) => {
      // List of searchable columns
      const searchableFields = [
        check.checkSerial,
        check.checkAmount,
        check.checkDate,
        check.bankName,
        check.accountNumber,
        check.payableTo,
        check.reason,
      ];

      // Checks if the search term exists in any of the specified columns
      return searchableFields.some((field) =>
        String(field).toLowerCase().includes(query)
      );
    });
  }

  return result;
});

const filteredChecksReceive = computed(() => {
  let result = checksReceive.value;

  if (activeStatusFilterReceive.value !== "همه") {
    result = result.filter(
      (check) => check.status === activeStatusFilterReceive.value
    );
  }

  const query = searchQueryReceive.value.toLowerCase().trim();
  if (query) {
    result = result.filter((check) => {
      const searchableFields = [
        check.checkSerial,
        check.checkAmount,
        check.checkDate,
        check.bankName,
        check.accountNumber,
        check.payableTo,
        check.reason,
      ];
      return searchableFields.some((field) =>
        String(field).toLowerCase().includes(query)
      );
    });
  }

  return result;
});

const filteredChecksFree = computed(() => {
  let result = checksFree.value;

  if (activeStatusFilterFree.value !== "همه") {
    result = result.filter(
      (check) => check.status === activeStatusFilterFree.value
    );
  }

  const query = searchQueryFree.value.toLowerCase().trim();
  if (query) {
    result = result.filter((check) => {
      const searchableFields = [
        check.checkSerial,
        check.checkAmount,
        check.checkDate,
        check.bankName,
        check.accountNumber,
        check.payableTo,
        check.reason,
      ];
      return searchableFields.some((field) =>
        String(field).toLowerCase().includes(query)
      );
    });
  }

  return result;
});

// --- Methods ---
function handleIssueCheck() {
  // Basic validation
  if (!form.checkSerial || !form.checkAmount) {
    alert("لطفاً سریال و مبلغ چک را وارد کنید.");
    return;
  }

  // Create a new check object
  const newCheck = {
    id: Date.now(), // Unique ID
    ...form,
    bankName: "ملت", // This value should come from another source
    status: "درحال وصول", // Default status for an issued check
  };

  // Add the new check to the beginning of the array
  checks.value.unshift(newCheck);

  // Reset the form
  Object.keys(form).forEach((key) => {
    if (key === "checkType") {
      form[key] = "چک روز";
    } else if (typeof form[key] === "number") {
      form[key] = null;
    } else {
      form[key] = "";
    }
  });
}

function handleReceiveCheck() {
  if (!formReceive.checkSerial || !formReceive.checkAmount) {
    alert("لطفاً سریال و مبلغ چک دریافتی را وارد کنید.");
    return;
  }

  const newCheck = {
    id: Date.now(),
    ...formReceive,
    bankName: "ملت",
    status: "درحال وصول",
  };

  checksReceive.value.unshift(newCheck);

  Object.keys(formReceive).forEach((key) => {
    if (key === "checkType") {
      formReceive[key] = "چک روز";
    } else if (typeof formReceive[key] === "number") {
      formReceive[key] = null;
    } else {
      formReceive[key] = "";
    }
  });
}

function handleFreePrintCheck() {
  if (!formFree.checkSerial || !formFree.checkAmount) {
    alert("لطفاً سریال و مبلغ چک چاپ آزاد را وارد کنید.");
    return;
  }

  const newCheck = {
    id: Date.now(),
    ...formFree,
    bankName: "ملت",
    status: "درحال وصول",
  };

  checksFree.value.unshift(newCheck);

  Object.keys(formFree).forEach((key) => {
    if (key === "checkType") {
      formFree[key] = "چک روز";
    } else if (typeof formFree[key] === "number") {
      formFree[key] = null;
    } else {
      formFree[key] = "";
    }
  });
}
</script>

<style scoped>
.header {
  width: 100%;
  text-align: right;
  color: #202020;
}

.check-management-container {
  direction: rtl;
  padding: 20px;
}

.tabs-nav {
  display: flex;
  gap: 10px;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 10px;
}

.tab-button {
  padding: 10px 20px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-size: 16px;
  color: #9aa2ac;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease-in-out;
}

.tab-button:hover {
  color: #202020;
}

.tab-button.active {
  color: #1476f3;
  border-bottom-color: #1476f3;
  font-weight: bold;
}

.tab-content {
  padding: 10px;
}

/* کلید اصلی طرح‌بندی فرم */
.check-form {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 4 ستون با عرض یکسان */
  gap: 20px; /* فاصله بین اینپوت‌ها */
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  margin-bottom: 5px;
  color: #5d5d5d;
  text-align: justify;
}

.form-group input,
select {
  padding: 5px;
  border: 1px solid #9aa2ac;
  border-radius: 10px;
  text-align: start;
}

/* اگر در <style scoped> می‌نویسید از :deep استفاده کنید */
.p-date {
  border: 1px solid var(--text-color-secondary);
  border-radius: 10px;
  text-align: start;
  overflow: hidden;
  background-color: var(--background-color);
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.p-date :deep(.vpd-container) {
  border: 1px solid rgba(var(--text-color-secondary-rgb), 0.12);
  border-radius: 0.75rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  background-color: var(--background-color);
}

.p-date :deep(.vpd-input-group label) {
  background-color: var(--background-color-button) !important;
}

.p-date :deep(.vpd-input-group input) {
  border: none !important;
  line-height: 32px !important;
  background-color: var(--background-color) !important;
  color: var(--text-color-primary) !important;
}

.p-date :deep(.vpd-input-group input::placeholder) {
  color: var(--text-color-secondary) !important;
  opacity: 1;
}

.p-date :deep(.vpd-input-group input:focus) {
  border: 1px solid transparent !important;
}

.p-date :deep(.vpd-icon-btn),
.p-date :deep(button.vpd-icon-btn),
.p-date :deep(.vpd-actions button) {
  background-color: var(--background-color-button) !important;
  color: var(--background-color) !important;
  transition: background-color 0.3s ease !important;
}

.p-date :deep(.vpd-icon-btn svg),
.p-date :deep(button.vpd-icon-btn svg),
.p-date :deep(.vpd-actions button svg),
.p-date :deep(.vpd-icon-btn svg path),
.p-date :deep(button.vpd-icon-btn svg path),
.p-date :deep(.vpd-actions button svg path) {
  fill: var(--background-color) !important;
  color: var(--background-color) !important;
  stroke: var(--background-color) !important;
}

.p-date :deep(.vpd-icon-btn:hover),
.p-date :deep(button.vpd-icon-btn:hover),
.p-date :deep(.vpd-actions button:hover) {
  background-color: var(--background-color-button-hover) !important;
}

input#general-search {
  width: 100%;
  padding: 6px;
  border: 1px solid #9aa2ac;
  border-radius: 10px;
  text-align: start;
}

.form-group input:focus {
  outline: none;
  border-color: #202020;
}

.search {
  flex-grow: 1;
  display: flex;
  align-items: center;
}

.form-actions {
  display: flex;
  justify-content: flex-start;
  margin-top: 24px;
}

.form-group-table {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
}

/* submit-button replaced by BaseButton (variant="primary") */

.table-section {
  margin-top: 40px;
  border-top: 1px solid #e5e7eb;
  padding-top: 24px;
}

.table-controls {
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  margin-bottom: 20px;
}

.status-filters {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  border-bottom: 1px solid #e0e0e0;
}

.status-button {
  padding: 8px 16px;
  border-bottom: 1px solid transparent;
  border-radius: 0;
  background-color: transparent;
  color: #9aa2ac;
  cursor: pointer;
  transition: all 0.2s;
  border-top: 0;
  border-right: 0;
  border-left: 0;
  display: inline-flex;
  align-items: center;
}

.status-button:hover {
  color: #202020;
}

.status-button.active {
  background-color: transparent;
  color: #1476f3;
  border-bottom: 1px solid #1476f3;
}

.table-wrapper {
  overflow-x: auto; /* برای واکنشگرایی در موبایل */
}

.checks-table {
  width: 100%;
  border-collapse: collapse;
  text-align: right;
}

.checks-table th,
.checks-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #e5e7eb;
  white-space: nowrap;
}

.checks-table thead {
  background-color: #f9fafb;
}

.checks-table th {
  font-weight: bold;
  color: #5d5d5d;
  border: 1px solid #e0e0e0;
  font-size: calc(0.3vw + 8px);
}

.checks-table tbody tr:hover {
  background-color: #f3f4f6;
}

.empty-row td {
  text-align: center;
  padding: 40px;
  color: #6b7280;
  border: 1px solid #e0e0e0;
}

.status-badge {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  color: white;
}

.color-indicator {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 3px;
  /* Adds space between the square and the text */
  margin-left: 8px;
}

.status-badge.درحال-وصول,
.color-indicator.درحال-وصول {
  background-color: #f59e0b;
}
.status-badge.پاس-شده,
.color-indicator.پاس-شده {
  background-color: #10b981;
}
.status-badge.برگشت-شده,
.color-indicator.برگشت-شده {
  background-color: #ef4444;
}
.status-badge.واگذار-شده,
.color-indicator.واگذار-شده {
  background-color: #6366f1;
}
.status-badge.ابطال-شده,
.color-indicator.ابطال-شده {
  background-color: #6b7280;
}
.status-badge.عودت,
.color-indicator.عودت {
  background-color: #8b5cf6;
}
</style>
